<router-outlet></router-outlet>

<div id="plane-spinner" style="display: none; width: 100%">
  <app-plane-spinner [showLoading]="false" />
</div>

<div
  class="load-Info d-flex align-items-center justify-content-center d-none"
  #loadagencyinfo
>
  <img src="../assets/images/FlightFusionLogo.png" alt="Flight Fusion Logo" />

  <div>
    <i class="fa-solid fa-plane primary-text" #loadagencyinfoicon></i>
  </div>

  <div class="loading-dots d-flex align-items-center mt-3">
    <p class="m-0 mend-2">Loading</p>
    <span class="mblock-start-2"></span>
    <span class="mblock-start-2"></span>
    <span class="mblock-start-2"></span>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-beat"
  [fullScreen]="true"
></ngx-spinner>
